<template>
  <div class="nfse-nacional-main">
    <div v-if="nfseNacional.dados.id">
      <Button
          _key="btnNfseCreate"
          title="NFSe"
          classIcon="fas fa-plus-circle"
          type="primary"
          size="small"
          eventName="nfseNacionalCreate"
          :clicked="createNew"
      />
      <div class="nfse-nacional-dropdown side-by-side">
        <DropdownOptions
            :urlPdf="nfseNacional.dados.urlPdf"
            :urlReceita="nfseNacional.dados.urlReceita"
            :urlXml="nfseNacional.dados.urlXml"
            :status="nfseNacional.dados.status"
            source="nfse-nacional"
        />
      </div>
      <br/>
      <Badge
          v-if="nfseNacional.dados.numero"
          :title="'Nº ' + nfseNacional.dados.numero.toString()"
          type="primary"
          size="medium"
      />
      <Badge
          :title="titleStatus()"
          :type="typeStatus()"
          size="small"
      />
      <MensagemErro
          :status="nfseNacional.dados.status"
          :mensagemErro="nfseNacional.dados.mensagemErro"
      />
      <EmProcessamento
          :status="nfseNacional.dados.status"
          updateButtonKey="btnUpdateNfseNacional"
      />
      <div class="nfse-nacional-total">
        <DisplayTotalization
            title="Nota"
            :value="nfseNacional.dados.valorNota"
        />
        <DisplayTotalization
            title="Impostos Aprox..."
            _style="color: red"
            :value="nfseNacional.dados.valorImposto"
        />
        <DisplayTotalization
            title="Final"
            _style="color: darkBlue"
            :value="nfseNacional.dados.valorFinal"
        />
      </div>
    </div>

    <b-tabs>
      <b-tab title="Dados">
        <Dados
            v-model="nfseNacional.dados"
            :disabled="disabled"
        />
      </b-tab>
      <b-tab title="Regime Tributário">
        <RegimeTributario
            :disabled="disabled"
            :ehSimplesNacional="ehSimplesNacional"
            v-model="nfseNacional.regimeTributario"
        />
      </b-tab>
      <b-tab
          v-if="id && (userLogged.user.userName === 'UserTemp' || hasRule('Audit'))"
          title="Auditoria"
      >
        <TimelineLog :id="id"/>
      </b-tab>
      <b-tab
          v-if="userLogged.user.userName == 'UserTemp'"
          title="Json"
      >
        <JsonInterpreter
            :jsonData="nfseNacional.dados.json"
            :nf="nfseNacional.dados"
            source="nfse-nacional"
        />
      </b-tab>
    </b-tabs>

    <div class="nfse-nacional-local-checkbox">
      <CheckboxSimple
          title="Local do Evento"
          v-model="mostrarAbaLocalEvento"
      />
    </div>

    <div
        v-show="mostrarAbaLocalEvento"
        class="nfse-nacional-local"
    >
      <b-tabs>
        <b-tab title="Local Evento">
          <LocalEvento
              :disabled="disabled"
              :rentId="nfseNacional.dados.locacao.id"
              v-model="nfseNacional.localEvento"
          />
        </b-tab>
      </b-tabs>
    </div>
    <br v-show="!mostrarAbaLocalEvento"/>

    <b-tabs>
      <b-tab title="Impostos">
        <Imposto
            :disabled="disabled"
            :ehSimplesNacional="ehSimplesNacional"
            v-model="nfseNacional.imposto"
        />
      </b-tab>
      <b-tab title="Totalização de Impostos">
        <Transparencia
            :disabled="disabled"
            :ehSimplesNacional="ehSimplesNacional"
            v-model="nfseNacional.transparencia"
        />
      </b-tab>
    </b-tabs>
  </div>
</template>

<script>
import Button from "@nixweb/nixloc-ui/src/component/forms/Button";
import Badge from "@nixweb/nixloc-ui/src/component/layout/Badge.vue";
import CheckboxSimple from "@nixweb/nixloc-ui/src/component/forms/CheckboxSimple.vue";
import DisplayTotalization from "@nixweb/nixloc-ui/src/component/rental/DisplayTotalization";

import DropdownOptions from "../nfse-shared/NfseDropdownOptions.vue";
import EmProcessamento from "../nfse-shared/NfseEmProcessamento.vue";
import LocalEvento from "../nfse-shared/NfseLocalEvento.vue";
import MensagemErro from "../nfse-shared/NfseMensagemErro.vue";
import JsonInterpreter from "../json/JsonInterpreter.vue";
import TimelineLog from "../../adm/audit-log/TimelineLog.vue";

import Dados from "./Dados.vue";
import Imposto from "./Imposto.vue";
import NfseNacional from "./NfseNacional.js";
import RegimeTributario from "./RegimeTributario.vue";
import Transparencia from "./Transparencia.vue";
import {getNfseStatusTitle, getNfseStatusType,} from "../nfse-shared/NfseStatus.js";

import {mapActions, mapGetters, mapMutations, mapState} from "vuex";

export default {
  name: "NfseNacionalCreateUpdate",
  components: {
    Badge,
    Button,
    CheckboxSimple,
    DisplayTotalization,
    Dados,
    RegimeTributario,
    Imposto,
    Transparencia,
    LocalEvento,
    MensagemErro,
    EmProcessamento,
    DropdownOptions,
    JsonInterpreter,
    TimelineLog,
  },
  data() {
    return {
      id: this.$route.params.id,
      urlCreate: "/api/v1/tax-document/nfse-nacional/create",
      urlUpdate: "/api/v1/tax-document/nfse-nacional/update",
      urlGetById: "/api/v1/tax-document/nfse-nacional/get-by-id",
      urlGetRegimeTributario: "/api/v1/tax-document/config-company/get-by-id",
      urlGetTaxationById: "/api/v1/tax-document/taxation/get-by-id",
      ehSimplesNacional: false,
      mostrarAbaLocalEvento: false,
      loadingTaxationValidation: false,
      taxationValidationRequestId: 0,
      nfseNacional: {
        dados: new NfseNacional().dados,
        regimeTributario: new NfseNacional().regimeTributario,
        imposto: new NfseNacional().imposto,
        transparencia: new NfseNacional().transparencia,
        localEvento: new NfseNacional().localEvento,
      },
      loading: true,
    };
  },
  mounted() {
    if (this.id) {
      this.getById();
    } else {
      this.obterRegimeTributarioEmpresa();
    }
  },
  computed: {
    ...mapState("user", ["userLogged"]),
    ...mapGetters("generic", ["event"]),
    ...mapGetters("user", ["hasRule"]),
    disabled() {
      const statusHabilitados = [1, 2, 4];
      return statusHabilitados.includes(this.nfseNacional.dados.status);
    },
  },
  methods: {
    ...mapActions("generic", ["postApi", "putApi", "getApi"]),
    ...mapMutations("generic", ["removeLoading"]),
    ...mapMutations("validation", ["removeFormDirty"]),
    titleStatus() {
      return getNfseStatusTitle(this.nfseNacional.dados.status);
    },
    typeStatus() {
      return getNfseStatusType(this.nfseNacional.dados.status);
    },
    createNew() {
      this.$router.push({
        name: "nfseNacionalCreate",
      });
      this.removeLoading(["btnNfseCreate"]);
    },
    create() {
      const nfseNacional = this.createObj();
      let params = {url: this.urlCreate, obj: nfseNacional};
      this.postApi(params).then((response) => {
        if (response.success) {
          this.$router.replace({
            name: "nfseNacionalUpdate",
            params: {id: response.content.id},
          });
        }
        this.removeLoading(["saveSaveCancel"]);
      });
    },
    update(notNotifyToast) {
      const nfseNacional = this.createObj();

      let params = {
        url: this.urlUpdate,
        obj: nfseNacional,
        notNotifyToast: notNotifyToast,
      };
      this.putApi(params).then((response) => {
        this.getById();
        this.removeLoading(["saveSaveCancel"]);
      });
    },
    getById() {
      let params = {url: this.urlGetById, obj: {id: this.id}};
      this.getApi(params).then((response) => {
        const data = response.content;

        const codigoOpcaoSimplesNacional = Number(
            data.regimeTributario.codigoOpcaoSimplesNacional.id
        );
        this.ehSimplesNacional = codigoOpcaoSimplesNacional !== 1;

        this.updateObj(data);
        const nomeEvento = this.nfseNacional?.localEvento?.nomeEvento;
        if (
            nomeEvento !== null &&
            nomeEvento !== undefined &&
            String(nomeEvento).trim() !== ""
        ) {
          this.mostrarAbaLocalEvento = true;
        }

        let self = this;
        setTimeout(function () {
          self.removeLoading(["panel", "btnUpdateNfseNacional"]);
          self.removeFormDirty();
        }, 100);
      });
    },
    obterRegimeTributarioEmpresa() {
      this.loading = true;
      let params = {url: this.urlGetRegimeTributario, obj: {}};
      this.getApi(params)
          .then((response) => {
            if (response.success) {
              const data = response.content;
              this.ehSimplesNacional = data.simplesNacional;
            }
          })
          .finally(() => {
            this.loading = false;
          });
    },
    createObj() {
      return NfseNacional.createObj(this.nfseNacional, this.ehSimplesNacional);
    },
    updateObj(data) {
      NfseNacional.updateObj(this.nfseNacional, data);
    },
    limparLocalEventoComNull() {
      this.nfseNacional.localEvento = {
        codigoEvento: null,
        nomeEvento: null,
        dataInicioEvento: null,
        dataFimEvento: null,
        cepEvento: null,
        logradouroEvento: null,
        numeroEvento: null,
        complementoEvento: null,
        bairroEvento: null,
      };
    },
    validarServicoParaLocalEvento(servicoId) {
      const nomeEvento = this.nfseNacional?.localEvento?.nomeEvento;
      const manterLocalEventoExistente =
          this.id &&
          nomeEvento !== null &&
          nomeEvento !== undefined &&
          String(nomeEvento).trim() !== "";

      if (manterLocalEventoExistente) {
        this.mostrarAbaLocalEvento = true;
        return;
      }

      if (!servicoId) {
        this.mostrarAbaLocalEvento = Boolean(manterLocalEventoExistente);

        if (!manterLocalEventoExistente) {
          this.limparLocalEventoComNull();
        }

        return;
      }

      this.loadingTaxationValidation = true;
      const requestId = ++this.taxationValidationRequestId;
      const params = {url: this.urlGetTaxationById, obj: {id: servicoId}};

      this.getApi(params)
          .then((response) => {
            if (requestId !== this.taxationValidationRequestId) return;

            const taxation = response?.content || {};
            const codigo = String(
                taxation.Codigo ?? taxation.codigo ?? taxation.code ?? ""
            );
            const exibirLocalEvento = codigo.startsWith("12");

            this.mostrarAbaLocalEvento =
                exibirLocalEvento || Boolean(manterLocalEventoExistente);

            if (!exibirLocalEvento && !manterLocalEventoExistente) {
              this.limparLocalEventoComNull();
            }
          })
          .catch(() => {
            if (requestId !== this.taxationValidationRequestId) return;

            this.mostrarAbaLocalEvento = Boolean(manterLocalEventoExistente);

            if (!manterLocalEventoExistente) {
              this.limparLocalEventoComNull();
            }
          })
          .finally(() => {
            if (requestId !== this.taxationValidationRequestId) return;
            this.loadingTaxationValidation = false;
          });
    },
  },
  watch: {
    "nfseNacional.dados.servico.id": {
      handler(servicoId) {
        this.validarServicoParaLocalEvento(servicoId);
      },
      immediate: true,
    },
    mostrarAbaLocalEvento: {
      handler(novoValor) {
        if (!novoValor) {
          this.limparLocalEventoComNull();
        }
      },
    },
    event: {
      handler(event) {
        if (event.name == "saveSaveCancel") {
          if (!this.nfseNacional.dados.id) this.create();
          if (this.nfseNacional.dados.id) this.update();
        }

        if (event.name == "updateNfse") {
          this.update(true);
        }

        if (event.name == "refreshNfse") {
          this.getById();
        }
      },
      deep: true,
    },
  },
};
</script>

<style scoped>
.nfse-nacional-main {
  margin-top: 40px;
}

.nfse-nacional-local {
  margin-top: 10px;
  margin-bottom: 15px;
}

.nfse-nacional-local-checkbox {
  margin-top: 20px;
}

.nfse-nacional-dropdown {
  margin-bottom: 20px;
  margin-left: -5px;
}

.nfse-nacional-total {
  margin-top: 20px;
}
</style>
